import { FC } from 'react';
import { useQuery } from 'react-query';
import { useAuth } from '../auth/AuthProvider';
import { getRequestHeaders, vake_api_server_url } from '../requests/helpers';
import { GridPageDisplay, Site } from './Admin';
import { Loading } from './loading/loading';

const useGetUserSites = () => {
    const { token } = useAuth();
    const url = `${vake_api_server_url}/user/get-user-sites`;
    return useQuery<Site[]>(['admin_sites'], async () => {
        const res = await fetch(url, {
            credentials: 'include',
            headers: getRequestHeaders(token),
        });
        if (!res.ok) {
            throw new Error(res.statusText);
        }

        return await res.json();
    });
};

const UserPanel: FC = () => {
    const { data: userSites, isLoading, isError } = useGetUserSites();
    if (isError) {
        return <div>Fetching data failed</div>;
    }
    if (isLoading) {
        return <Loading />;
    }
    return (
        <div className="flex items-center justify-center h-screen w-fill bg-background-primary">
            {typeof userSites !== 'undefined' ? <GridPageDisplay websites={userSites} /> : null}
        </div>
    );
};

export default UserPanel;
